import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultComplexFontSetting,
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "btnSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      widthVal: 32,
      heightVal: 32,
      widthAuto: true,
      heightAuto: true,
    },
    extraConfig: {
      noFull: true,
    }
  },
  {
    name: "btnText",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex',
      textAlign: "center",
    }
  },
  {
    name: "btnTextHover",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex',
      textAlign: "center",
    }
  },
  {
    name: "btnTextActive",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex',
      textAlign: "center",
    }
  },
  {
    name: 'iconPosition',
    desc: '位置',
    type: "sliderSet",
    defaultValue: "top",
    extraConfig: {
      options: [
        {
          value: "top",
          title: "上",
        },
        {
          value: "bottom",
          title: "下",
        },
        {
          value: "left",
          title: "左",
        },
        {
          value: "right",
          title: "右",
        },
      ],
    },
  },
  {
    name: "iconMargin",
    desc: "间距",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      suffix: "px",
    }
  },
  {
    name: "iconSize",
    desc: "大小",
    type: "numberSet",
    defaultValue: 32,
    unit: "px",
    extraConfig: {
      suffix: "px",
    }
  },
  {
    name: "btnBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "btnBackgroundActive",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: [{
      color: "rgba(237, 241, 247, 1)",
      type: "color",
      label: "颜色",
      isThemeColor: false
    }]
  },
  {
    name: "btnBackgroundHover",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: [{
      color: "rgba(237, 241, 247, 1)",
      type: "color",
      label: "颜色",
      isThemeColor: false
    }]
  },
  {
    name: "showBtnBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "showBtnBorderHover",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "showBtnBorderActive",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "btnBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnBorderHover",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnBorderActive",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 4
    }
  },
  {
    name: "btnRadiusHover",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 4
    }
  },
  {
    name: "btnRadiusActive",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 4
    }
  },
  {
    name: "btnOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "btnOpacityActive",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "btnOpacityHover",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "btnShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "btnShadowActive",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "btnShadowHover",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "activeIsSameWithHover",
    desc: "同选中状态",
    type: "booleanSet",
    defaultValue: true
  }
]

export const menuSetting = [
  {
    type: "status",
    statusSettings: [
      {
        title: "默认",
        settings: [
          {
            type: "collapse",
            title: "尺寸",
            settings: ["btnSize"]
          },
          {
            type: "collapse",
            title: "文字",
            settings: ["btnText"]
          },
          {
            type: "collapse",
            title: "图标",
            settings: ["iconPosition", "iconMargin", "iconSize"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["btnBackground"]
          },
          {
            type: "collapse",
            title: "边框",
            initStatus: 'closed',
            settings: [
              {
                type: "basic",
                name: "btnBorder",
              },
              "btnRadius"
            ]
          },
          {
            type: "collapse",
            title: "更多",
            initStatus: 'closed',
            settings: ["btnOpacity", "btnShadow"]
          }
        ]
      },
      {
        title: "选中",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: ["btnTextActive"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["btnBackgroundActive"]
          },
          {
            type: "collapse",
            title: "边框",
            initStatus: 'closed',
            settings: [{type: "basic", name: "btnBorderActive"}, "btnRadiusActive"]
          },
          {
            type: "collapse",
            title: "更多",
            initStatus: 'closed',
            settings: ["btnOpacityActive", "btnShadowActive"]
          }
        ]
      },
      {
        title: "悬停",
        settings: [
          'activeIsSameWithHover',
          {
            type: 'collection',
            enable(config) {
              return !config.activeIsSameWithHover
            },
            settings: [
              {
                type: "collapse",
                title: "文字",
                settings: ["btnTextHover"]
              },
              {
                type: "collapse",
                title: "背景",
                settings: ["btnBackgroundHover"]
              },
              {
                type: "collapse",
                title: "边框",
                initStatus: 'closed',
                settings: [{type: "basic", name: "btnBorderHover"}, "btnRadiusHover"]
              },
              {
                type: "collapse",
                title: "更多",
                initStatus: 'closed',
                settings: ["btnOpacityHover", "btnShadowHover"]
              }
            ]
          }   
        ]
      }
    ]
  }
]
